// Please add the prefix "countdownCookie_" to a cookie name

const countdownCookies = {
  newRootPage: 'countdownCookie_rootPage',
  newFreeTrialPage: 'countdownCookie_newFreeTrialPage',
  emailLandingPage: 'countdownCookie_emailLandingPage',
  emailQuizPage: 'countdownCookie_emailQuizPage',
  acquisitionPickPage: 'countdownCookie_acquisitionPickPage',
  subscribePageReferral: 'countdownCookie_subscribePageReferral',
}


export default countdownCookies
